<script setup>
import Card from '@/Components/Card/Card.vue';
import { inject } from 'vue';
import ACTION_TYPES from '@/Common/Enum/ActionType.js';
import ExplainScorePart from '@/Pages/DomainScore/Partials/DetailedReport/ExplainScorePart.vue';
import { API_STATUS } from '@/Common/Enum/ApiStatus.js';
import DetailedReportHeader from '@/Pages/DomainScore/Partials/DetailedReport/DetailedReportHeader.vue';
import { getMtaDnsRecordStatus } from '@/Common/DnsRecordMessaging.js';
import LinkDomainAnalysis from '@/Pages/DomainScore/Partials/DetailedReport/LinkDomainAnalysis.vue';

const result = inject('score');
const mtaDnsRecordStatus = getMtaDnsRecordStatus(result);
</script>

<template>
  <Card class="bg-white-opacity">
    <DetailedReportHeader
      :title="
        $t('domain_score.partials.detailed_report.privacy.mta_sts_card.mtasts')
      "
      :description="
        $t(
          'domain_score.partials.detailed_report.privacy.mta_sts_card.description'
        )
      "
      :tooltip="
        $t('domain_score.partials.detailed_report.privacy.mta_sts_card.tooltip')
      "
    />
    <div class="mt-5 flex flex-col">
      <ExplainScorePart
        :title="
          $t(
            'domain_score.partials.detailed_report.privacy.mta_sts_card.dns_record'
          )
        "
        :action-type="mtaDnsRecordStatus.actionType"
      >
        {{ mtaDnsRecordStatus.message }}
        <div v-if="mtaDnsRecordStatus.canAnalyse">
          &nbsp;-
          <LinkDomainAnalysis :domain="result.domain" fragment="tls" />
        </div>
      </ExplainScorePart>

      <div v-if="result.records?.mtasts?.status !== API_STATUS.FATAL">
        <ExplainScorePart
          v-if="!result.records.mtasts.has_policy"
          :title="
            $t(
              'domain_score.partials.detailed_report.privacy.mta_sts_card.policy'
            )
          "
          :action-type="ACTION_TYPES.ACTION_REQUIRED"
        >
          {{
            $t(
              'domain_score.partials.detailed_report.privacy.mta_sts_card.policy_contain_errors'
            )
          }}
        </ExplainScorePart>

        <ExplainScorePart
          v-else-if="result.records.mtasts.policy_mode === 'enforce'"
          :title="
            $t(
              'domain_score.partials.detailed_report.privacy.mta_sts_card.policy'
            )
          "
          :action-type="ACTION_TYPES.NO_ACTION"
        >
          {{
            $t(
              'domain_score.partials.detailed_report.privacy.mta_sts_card.policy_set_to_enforce'
            )
          }}
        </ExplainScorePart>

        <ExplainScorePart
          v-else-if="result.records.mtasts.policy_mode === 'testing'"
          :title="
            $t(
              'domain_score.partials.detailed_report.privacy.mta_sts_card.policy'
            )
          "
          :action-type="ACTION_TYPES.ACTION_REQUIRED"
        >
          {{
            $t(
              'domain_score.partials.detailed_report.privacy.mta_sts_card.policy_set_to_testing'
            )
          }}
        </ExplainScorePart>

        <ExplainScorePart
          v-else-if="result.records.mtasts.policy_mode === 'none'"
          :title="
            $t(
              'domain_score.partials.detailed_report.privacy.mta_sts_card.policy'
            )
          "
          :action-type="ACTION_TYPES.ACTION_REQUIRED"
        >
          {{
            $t(
              'domain_score.partials.detailed_report.privacy.mta_sts_card.policy_set_to_none'
            )
          }}
        </ExplainScorePart>
      </div>
    </div>
  </Card>
</template>
